import React, { useState, useCallback } from 'react';
import { CustomSpinner } from '@components';
import { SearchResultProps, SearchInputProps } from '@interface';
import { debounce } from '@utils';
import { useDispatch } from 'react-redux';
import { setAddressState } from '@/store/slice';
import { searchPropertyAddress } from '@/store/addressSlice';
import { AppDispatch } from '@store';
import { addressListInterface } from '@/components/lookupInput/types';

const SearchResult: React.FC<SearchResultProps> = ({
	results,
	setAddressList,
	navigaterFunction,
}) => {
	const dispatch = useDispatch<AppDispatch>();
	return (
		<ul className="mt-1 border border-gray-300 bg-white divide-y divide-gray-200 z-50 absolute left-0 w-full text-left max-h-50 overflow-y-auto shadow-lg">
			{results.map((result: addressListInterface, index) => (
				<li
					key={index}
					className="px-4 py-2 text-[14px] font-semibold text-[#000] bg-[#fff] hover:bg-[#e1e1e1] cursor-pointer hover:underline"
					onClick={() => {
						result.properties.label !== 'No result.' &&
							dispatch(setAddressState(result));
						navigaterFunction();
						setAddressList([]);
					}}
				>
					{result.properties.label}
				</li>
			))}
		</ul>
	);
};

export const LookupInput: React.FC<SearchInputProps> = ({
	navigaterFunction,
}) => {
	const [address, setAddress] = useState<string>('');
	const [loading, setLoading] = useState(false);
	const [addressList, setAddressList] = useState<Array<addressListInterface>>([
		{
			properties: {
				name: '',
				borough: '',
				postalcode: '',
				label: 'No result.',
				addendum: {
					pad: {
						bbl: '',
					},
				},
			},
		},
	]);
	const dispatch = useDispatch<AppDispatch>();

	const fetchResults = async (query: string) => {
		if (!query) {
			setLoading(false);
			return setAddressList([]);
		}

		const response = await dispatch(searchPropertyAddress(query));
		if ('error' in response) {
			console.log("error", response?.error);
		} else {
			const { features } = response.payload;
			setAddressList(features);
		}
		setLoading(false);
	};

	const submitAddressSearch = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);
		debouncedFetchResults(address);
	};

	const debouncedFetchResults = useCallback(debounce(fetchResults, 1000), []);
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setAddress(e.target.value);
		setLoading(true);
		debouncedFetchResults(e.target.value);
	};

	return (
		<div className="w-full m-auto relative">
			<form
				className="flex justify-center md:ml-7"
				onSubmit={submitAddressSearch}
			>
				<div className="relative w-full">
					<input
						type="text"
						value={address}
						onChange={handleInputChange}
						placeholder="Enter an address"
						className="px-4 py-2 border focus:outline-none w-full"
					/>
					{address && (
						<div className="absolute w-full">
							<SearchResult
								navigaterFunction={navigaterFunction}
								results={
									addressList.length > 0
										? addressList
										: [
												{
													properties: {
														name: '',
														borough: '',
														postalcode: '',
														label: 'No result.',
														addendum: {
															pad: {
																bbl: '',
															},
														},
													},
												},
											]
								}
								setAddressList={setAddressList}
							/>
						</div>
					)}
				</div>

				<button
					type="submit"
					className="px-4 py-2 bg-[#324B69] text-white font-semibold hover:bg-[#495f7c] w-[100px]"
				>
					SEARCH
				</button>
				<div className="relative -left-[140px] top-[10px] w-[40px] z-[999]">
					{loading && <CustomSpinner />}
				</div>
			</form>
		</div>
	);
};
